var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2555 7.11404L7.11404 11.2555C6.58203 10.7235 6.25464 9.99506 6.25464 9.18477C6.25464 7.56418 7.56418 6.25464 9.18477 6.25464C9.99506 6.25464 10.7235 6.58203 11.2555 7.11404Z",
    stroke: "#445374",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9484 4.08572C12.5161 3.00532 10.8791 2.41602 9.18489 2.41602C6.29562 2.41602 3.60282 4.11846 1.7285 7.06499C0.991867 8.21906 0.991867 10.1589 1.7285 11.3129C2.3751 12.3278 3.1281 13.2036 3.94658 13.9075",
    stroke: "#445374",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25464 15.3482C7.18771 15.7411 8.17804 15.9539 9.18477 15.9539C12.074 15.9539 14.7668 14.2514 16.6411 11.3049C17.3778 10.1508 17.3778 8.21103 16.6411 7.05693C16.371 6.63132 16.0764 6.23026 15.7735 5.85376",
    stroke: "#445374",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0571 9.75806C11.8443 10.9121 10.9031 11.8534 9.74902 12.0662",
    stroke: "#445374",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11393 11.2554L0.999878 17.3694",
    stroke: "#445374",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3694 1L11.2554 7.11405",
    stroke: "#445374",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.69e05f407b7c413e5d6d8e1a50fedcf3.svg";
export { ForwardRef as ReactComponent };